export const initialState = {
  searchText: '',
  page: 1,
  catalogList: [],
  myPoint: 0,
  error: null,
  isFetch: false,
  totalCount: 0,
}
